module.exports = __webpack_public_path__ + "img/cargando.0efe7276.gif";